// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {useContext} from 'react';
import styles from './form.module.less';
import cn from 'classnames';
import {Settings_context} from '../../settings_ctx';
import hopt from 'hola_opt';

const A = props=><a target="_blank" rel="noopener noreferrer" {...props}>
    {props.children}</a>;

export const Footer = ({label, google_terms, img_set})=>{
    const {theme} = useContext(Settings_context);
    return <div className={cn(styles.login_footer)}>
      <p className={cn(theme.p5)}>
        By clicking {label},
        you agree you have read and accepted the <A href={
          img_set=='toolip' ? '/legal/terms_conditions' : '/legal/sla'}>
        {img_set=='toolip' ? 'toolip' : 'Hola'} End User Agreement</A> and
        the <A href={
          img_set=='toolip' ? '/legal/privacy_policy' : '/legal/privacy'}>
        {img_set=='toolip' ? 'toolip' : 'Hola'} Privacy Statement</A>.
      </p>
      {google_terms && (hopt.mtcaptcha && hopt.mtcaptcha.enable ?
      <p className={cn(theme.p5)}>
        This site is protected by MTCaptcha and the MTCaptcha <A
        href="https://www.mtcaptcha.com/legal-privacy-captcha"
        target="_blank" rel="noopener noreferrer">Privacy Policy</A> and <A
        href="https://www.mtcaptcha.com/legal-terms"
        target="_blank" rel="noopener noreferrer">Terms of Service</A> apply.
      </p> :
      <p className={cn(theme.p5)}>
        This site is protected by reCAPTCHA and the Google <A
        href="https://policies.google.com/privacy">Privacy Policy</A> and <A
        href="https://policies.google.com/terms">Terms of Service</A> apply.
      </p>)}
    </div>;
};
